import { createSlice } from '@reduxjs/toolkit';
import { getUserSchoolProperty } from '../utils/utils';
import sectorLanguageTypes from '../enums/sectorLanguageTypes';

const initialState = {
    lang: null,
    texts: {},
}

const translateSlice = createSlice({
    name: "translate",
    initialState,
    reducers: {
        initText(state, action) {
            state.texts = action.payload.texts;
        },
        initLang(state, action) {
            const { currentLnag, user, userDetails } = action.payload;
            if (currentLnag)
                state.lang = currentLnag;
            else if (user) {
                if (userDetails) {
                    const storageKey = `LANG-${user.exidentifier}`;
                    try {
                        let lang = localStorage.getItem(storageKey);
                        if (!lang) {
                            const sectorId = getUserSchoolProperty(userDetails, 'sectorId') || 1;
                            const defaultLang = sectorLanguageTypes[sectorId];
                            localStorage.setItem(storageKey, defaultLang);
                            lang = defaultLang;
                        }
                        state.lang = lang;
                    } catch (error) {
                        console.error('Error in setLang:', error);
                    }
                }
            }
            else
                state.lang = "he"
        }
    }
})

export const translateActions = translateSlice.actions;
export default translateSlice
